import { render, staticRenderFns } from "./meeting-list.vue?vue&type=template&id=27b2309c&scoped=true&"
import script from "./meeting-list.vue?vue&type=script&lang=js&"
export * from "./meeting-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b2309c",
  null
  
)

export default component.exports